import DynamicTable from '@atlaskit/dynamic-table';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { REPORTS_ROWS_PER_PAGE } from '../../../../constants/Preferences';
import NoResultView from '../../../../utils/NoResultView';
import { REPORTS_NO_RESULT_SUBTITLE, REPORTS_NO_RESULT_TITLE } from '../../PartnerReports.constants';
import { getSalesOrEvaluationsSummary } from './SalesOrEvaluationsTableAllApps';
import getSalesOrEvaluationsBody from './SalesOrEvaluationsTableBody';
import getSalesOrEvaluationsHead from './SalesOrEvaluationsTableHead';
const SalesOrEvaluationsTable = props => {
  const salesOrEvaluationsSummary = getSalesOrEvaluationsSummary(props.reportName, props.reportBy, props.onRowClick, props.totalSeries);
  return /*#__PURE__*/React.createElement(DynamicTable, {
    head: getSalesOrEvaluationsHead(props.reportName, props.reportBy),
    rowsPerPage: DynamicTableUtils.getRowsPerPage(props.allReportingApps.length, REPORTS_ROWS_PER_PAGE),
    rows: [...salesOrEvaluationsSummary, ...getSalesOrEvaluationsBody(props.reportApps, props.reportName, props.reportBy, props.allReportingApps, props.onRowClick, props.selectedAppKey)],
    defaultSortKey: "total",
    defaultSortOrder: "DESC",
    emptyView: /*#__PURE__*/React.createElement(NoResultView, {
      title: REPORTS_NO_RESULT_TITLE,
      subtitle: REPORTS_NO_RESULT_SUBTITLE
    })
  });
};
export default SalesOrEvaluationsTable;